import { connect } from 'react-redux';

import StudyListRout2e from './StudyListRoute.js';

const isActive = a => a.active === true;

const mapStateToProps = state => {
  const activeServer = state.servers.servers.find(isActive);

  return {
    server: activeServer,
    user: state.oidc.user,
    // user: { name: '2222' },
  };
};

const ConnectedStudyList = connect(
  mapStateToProps,
  null
)(StudyListRout2e);

export default ConnectedStudyList;
